export default function (event) {
  var evt = event || window.event;
  if ("buttons" in evt) {
    return evt.buttons == 1;
  }
  var button = evt.which || evt.button;
  return button == 1 || evt.touches || evt.changedTouches;
}